import styled from "styled-components";
import {SPACE, SMALL_SPACE} from "components/theme";

export const Page = styled.div`
  height: calc(100vh - 65px);
  display: flex;
  flex-direction: column;
`;

export const WrapTopbar = styled.div`
  width: 100%;

  .admin-topbar {
    z-index: 1000;
    padding-top: 5px;

    h4 {
      font-weight: normal;
    }

    border-bottom: 1px solid #dedede;
  }
`;

export const Title = styled.div`
  flex-grow: 1;
  font-size: 24px;
  font-weight: 400;
  letter-spacing: normal;
  padding-left: ${SMALL_SPACE};
`;

export const Content = styled.div`
  flex-grow: 1;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding: ${props => props.padding ? props.padding : `${SMALL_SPACE} ${SPACE} 0 ${SPACE}`};
`;

export const WrapActions = styled.div`
  margin-left:5px;
`;
